/*
var scrollDown = true
var scrollTemp = 0
var ticking = false
*/
gsap.registerPlugin(ScrollTrigger);

window.addEventListener("DOMContentLoaded", function () {
  // Mot de passe ?
  if (document.querySelector("#RecoverPassword")) {
    document
      .querySelector("#RecoverPassword")
      .addEventListener("click", function (e) {
        e.preventDefault();
        document.querySelector("#RecoverPasswordForm").classList.remove("hide");
        document.querySelector("#CustomerLoginForm").classList.add("hide");
      });

    document
      .querySelector("#HideRecoverPasswordLink")
      .addEventListener("click", function (e) {
        e.preventDefault();
        document.querySelector("#RecoverPasswordForm").classList.add("hide");
        document.querySelector("#CustomerLoginForm").classList.remove("hide");
      });
  }

  // code promotionnel
  if (document.querySelector("#shopify-section-announcement-bar")) {
    document
      .querySelector("#shopify-section-announcement-bar")
      .addEventListener("click", function () {
        if (document.querySelector("#resell-widget-btn")) {
          document.querySelector("#resell-widget-btn").click();
        }
      });
  }

  if (document.querySelector(".c-product_content")) {
    const productID = document.querySelector(".c-product_content").dataset.id;

    // Mélanie
    // à chaque chargement de page tableau vide
    var products = [];
    if (localStorage.getItem("recentlyViewed")) {
      var storedProducts = JSON.parse(localStorage.getItem("recentlyViewed"));
      products = storedProducts;

      if (products.includes(productID) !== true) {
        products.push(productID);
        localStorage.setItem("recentlyViewed", JSON.stringify(products));
      }
    } else {
      products.push(productID);
      localStorage.setItem("recentlyViewed", JSON.stringify(products));
    }

    if (window.innerWidth < 1001) {
      let productContentBottom;
      let scrollCalc;
      window.addEventListener("scroll", function () {
        productContentBottom = document
          .querySelector(".c-product_content")
          .getBoundingClientRect().bottom;
        scrollCalc = productContentBottom - window.innerHeight;
        if (scrollCalc < 0) {
          document.querySelector(".c-submit").style.position = "absolute";
        } else {
          document.querySelector(".c-submit").style.position = "fixed";
        }
      });
    }
  }

  if (document.querySelector(".productZoom__items")) {
    // zoom
    if (window.innerWidth > window.innerHeight) {
      Array.prototype.forEach.call(
        document.querySelectorAll(".c-product_image"),
        function (el, i) {
          el.addEventListener("click", function (e) {
            if (i == 0)
              document.querySelector(".productZoom__prev").classList.add("off");
            if (i == document.querySelectorAll(".productZoom__item").length)
              document.querySelector(".productZoom__next").classList.add("off");
            Array.prototype.forEach.call(
              document.querySelectorAll(".productZoom__item.on"),
              function (el1, i1) {
                el1.classList.remove("on");
              }
            );
            document
              .querySelectorAll(".productZoom__item")
              [i].classList.add("on");
            document.querySelector(".productZoom").classList.add("on");
          });
        }
      );

      const pos = { y: window.innerHeight / 2 };
      const mouse = { y: pos.y };
      const ySet = gsap.quickSetter(
        document.querySelector(".productZoom__items"),
        "y",
        "px"
      );

      window.addEventListener("mousemove", (e) => {
        mouse.y = e.y;
      });

      gsap.ticker.add(() => {
        if (document.querySelector(".productZoom__item.on img")) {
          const dt = 1.0 - Math.pow(1.0 - 0.2, gsap.ticker.deltaRatio());
          var destY =
            ((window.innerHeight -
              document.querySelector(".productZoom__item.on img")
                .offsetHeight) *
              mouse.y) /
            window.innerHeight;
          pos.y += (destY - pos.y) * dt;
          ySet(pos.y);
        }
      });

      document
        .querySelector(".productZoom__prev")
        .addEventListener("click", function () {
          var current = indexInParent(
            document.querySelector(".productZoom__item.on")
          );
          current--;

          if (current == 0)
            document.querySelector(".productZoom__prev").classList.add("off");
          else
            document
              .querySelector(".productZoom__prev")
              .classList.remove("off");
          if (
            document
              .querySelector(".productZoom__next")
              .classList.contains("off")
          )
            document
              .querySelector(".productZoom__next")
              .classList.remove("off");

          document
            .querySelector(".productZoom__item.on")
            .classList.remove("on");
          document
            .querySelectorAll(".productZoom__item")
            [current].classList.add("on");
        });

      document
        .querySelector(".productZoom__next")
        .addEventListener("click", function () {
          var current = indexInParent(
            document.querySelector(".productZoom__item.on")
          );
          current++;
          if (
            current ==
            document.querySelectorAll(".productZoom__item").length - 1
          )
            document.querySelector(".productZoom__next").classList.add("off");
          else
            document
              .querySelector(".productZoom__next")
              .classList.remove("off");
          if (
            document
              .querySelector(".productZoom__prev")
              .classList.contains("off")
          )
            document
              .querySelector(".productZoom__prev")
              .classList.remove("off");

          document
            .querySelector(".productZoom__item.on")
            .classList.remove("on");
          document
            .querySelectorAll(".productZoom__item")
            [current].classList.add("on");
        });
    } else {
      // nav en mode portrait

      document
        .querySelector(".c-product_images .swiper-wrapper")
        .addEventListener("click", function (e) {
          var indexPhoto = 0;

          Array.prototype.forEach.call(
            document.querySelectorAll(".c-product_image.swiper-slide"),
            function (el, i) {
              if (el.classList.contains("swiper-slide-active")) indexPhoto = i;
            }
          );

          if (document.querySelector(".productZoom__item.on"))
            Array.prototype.forEach.call(
              document.querySelectorAll(".productZoom__item.on"),
              function (el) {
                el.classList.remove("on");
              }
            );
          document
            .querySelectorAll(".productZoom__item")
            [indexPhoto].classList.add("on"); // renvoie 2 mais que 2 images
          document.querySelector(".productZoom").classList.add("on");

          if (
            document
              .querySelector(".productZoom__item.on img")
              .parentNode.classList.contains("pinch-zoom-container") == false
          )
            new PinchZoom.default(
              document.querySelector(".productZoom__item.on img"),
              { draggableUnzoomed: false, minZoom: 1.5 }
            );
        });
    }

    document
      .querySelector(".productZoom")
      .addEventListener("click", function () {
        document.querySelector(".productZoom").classList.remove("on");
      });

    document
      .querySelector(".productZoom__close")
      .addEventListener("click", function () {
        document.querySelector(".productZoom").classList.remove("on");
        document.querySelector(".productZoom__item.on").classList.remove("on");
        // if(document.querySelector('.pinch-zoom-container') pz.disable();
      });
  }

  function appHeight() {
    document.documentElement.style.setProperty(
      "--app-height",
      window.innerHeight + "px"
    );
  }
  document.documentElement.style.setProperty(
    "--app-height-init",
    window.innerHeight + "px"
  );
  window.addEventListener("resize", appHeight);
  appHeight();

  /* grid */
  if (document.querySelector("body[local]"))
    document.addEventListener("keypress", logKey);

  Array.prototype.forEach.call(
    document.querySelectorAll(".c-productsList_slider"),
    function (el, i) {
      let sliderId = el.dataset.id;
      const swiper = new Swiper(".c-swiper_" + sliderId, {
        slidesPerView: "auto",
        spaceBetween: 5,
        // allowTouchMove: false,
        // simulateTouch: false,
        touchMoveStopPropagation: true,
        // slideToClickedSlide: false,
        // touchRatio: 1,
        focusableElements: "video",
        preventClicks: true,
        navigation: {
          nextEl: ".c-swiperNav_" + sliderId + ".c-nav_next",
          prevEl: ".c-swiperNav_" + sliderId + ".c-nav_prev",
        },
        breakpoints: {
          0: {
            slidesPerView: 1.3,
          },
          601: {
            slidesPerView: 3,
          },
          1000: {
            slidesPerView: "auto",
          },
        },
      });
    }
  );

  if (document.querySelector(".c-lookbook")) {
    Array.prototype.forEach.call(
      document.querySelectorAll(".c-lookbook"),
      function (el, i) {
        el.querySelector(".c-lookbook_image").addEventListener(
          "click",
          (event) => {
            el.querySelector(".c-lookbook_produits").classList.toggle(
              "-active"
            );
          }
        );
      }
    );
  }

  /* Produit card - swiper mobile */
  if (
    document.querySelector(".c-productCard_image") &&
    window.innerWidth < 1001
  ) {
    Array.prototype.forEach.call(
      document.querySelectorAll(".c-productCard_image.swiper"),
      function (el, i) {
        const swiper = new Swiper(el, {
          slidesPerView: "auto",
          spaceBetween: 0,
          pagination: {
            el: el.querySelector(".swiper-pagination"),
          },
        });
      }
    );
  }

  /* Produit card - quickview */
  if (document.querySelector(".c-productCard_item")) {
    Array.prototype.forEach.call(
      document.querySelectorAll(".c-productCard_item"),
      function (el, i) {
        if(el.querySelector(".c-productCard_quickview")) el.querySelector(".c-productCard_quickview").addEventListener(
          "click",
          function (e) {
            e.preventDefault();
            // el.querySelector('.c-productCard_image').preventDefault()
            el.querySelector(".c-quickview_popup").classList.toggle("-active");
          }
        );

        if (el.dataset.id == "carte-cadeau-laurence-bras") {
          console.log("pouet");
          Array.prototype.forEach.call(
            el.querySelectorAll('.c-optionsWrap input[type="radio"]'),
            function (item, i2) {
              item.addEventListener("change", function () {
                el.querySelector(".c-quickview_price").textContent =
                  item.dataset.value + ",00 €";
              });
            }
          );
        }
      }
    );
  }

  /* Quickview */
  if (
    document.querySelector(".c-quickview_slider") &&
    window.innerWidth > 1000
  ) {
    Array.prototype.forEach.call(
      document.querySelectorAll(".c-quickview_slider.swiper"),
      function (el, i) {
        const swiper = new Swiper(el, {
          slidesPerView: "auto",
          spaceBetween: 0,
          grabCursor: true,
          navigation: {
            nextEl: ".c-quickview_slider .swiper-next",
            prevEl: ".c-quickview_slider .swiper-prev",
          },
        });
      }
    );
  }

  if (document.querySelector(".c-quickview_popup")) {
    Array.prototype.forEach.call(
      document.querySelectorAll(".c-quickview_popup"),
      function (el, i) {
        el.querySelector(".c-quickview_close").addEventListener(
          "click",
          function () {
            el.classList.remove("-active");
          }
        );
      }
    );
  }

  /* emails ?? */
  if (document.querySelector(".c-email")) {
    Array.prototype.forEach.call(
      document.querySelectorAll(".c-email"),
      function (el, i) {
        el.addEventListener("click", function () {
          window.location.href =
            "mailto:" + ["eshop", "laurencebras.com"].join("@");
        });
      }
    );
  }

  /*
  window.addEventListener('scroll', function(e) {
    if (!ticking) window.requestAnimationFrame(function() { doSomething(window.scrollY); ticking = false; });
    ticking = true;
  });
  doSomething(0)
  */

  /*
  if(document.querySelector('.pop > button')) document.querySelector('.pop > button').addEventListener('click', function() {
    document.querySelector('.pop').classList.remove('on')
    document.querySelector('body').classList.remove('overflow')
  })
  */

  /* cart */
  /*
  document.querySelector('.cart').addEventListener('click', openOverlayCart)
  document.querySelector('.overlayCart__close').addEventListener('click', closeOverlayCart)
  */

  /*
  if(document.querySelector('#AddToCartForm')) {
    document.querySelector('#AddToCartForm').addEventListener('submit', function(e) {
      e.preventDefault()
      openOverlayCart()

      // add
      var request = new XMLHttpRequest();
      request.open('POST', '/cart/add.js', true);
      request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
      request.onload = updateCart
      var dataTemp = JSON.stringify(Object.fromEntries(new FormData(e.target)))
      request.send(dataTemp);
    })
  }
  */

  /* apparitions scroll */
  /*
  if(document.querySelector('[pamappear]')) {
    var observer = new IntersectionObserver(function(entries) {
      entries.map((entry) => {
            if(entry.isIntersecting) entry.target.classList.add('on')
            else entry.target.classList.remove('on')
        });
    })
    Array.prototype.forEach.call(document.querySelectorAll('[pamappear]'), function(el, i){ observer.observe(el) })
  }
  */
});

function doSomething() {}

/*

function updateCart() {
  document.querySelector('.overlayCart__items').innerHTML = '';
  var request = new XMLHttpRequest();
  request.open('GET', '/cart.js', true);
  request.onload = function() {
    var objet = JSON.parse(this.response)
    document.querySelector('.overlayCart__total--price').textContent = "€"+parseInt(objet.total_price/100).toFixed(2)
    if(objet.item_count==0) document.querySelector('.overlayCart').classList.add('empty')
    else if(document.querySelector('.overlayCart').classList.contains('empty')) document.querySelector('.overlayCart').classList.remove('empty')

    for(var i=0; i<objet.items.length; i++) {
      document.querySelector('.overlayCart__items').innerHTML += '<div class="overlayCart__item" data-id="'+objet.items[i].id+'"><div class="overlayCart__image"><img src="'+objet.items[i].image.replace('.jpg','_250x.jpg')+'"></div><div class="overlayCart__description"><div class="overlayCart__itemName">'+objet.items[i].product_title+'<br><strong>Monument</strong></div><div class="overlayCart__itemSize">'+objet.items[i].variant_options[0]+'</div><div class="overlayCart__itemPrice">'+parseInt(objet.items[i].price/100).toFixed(2)+'€ &times; ' + objet.items[i].quantity + '</div><div class="overlayCart__itemQuantity"><button onclick="reduceQty(this)"><</button> <span>'+objet.items[i].quantity+'</span> <button onclick="increaseQty(this)">></button></div></div></div>'
    }
  }
  request.send();

}


function reduceQty(el) {
  var request = new XMLHttpRequest();
  request.open('POST', '/cart/update.js', true);
  request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
  request.send('updates['+el.parentNode.parentNode.parentNode.dataset.id+']='+parseInt(parseInt(el.parentNode.querySelector('.overlayCart__itemQuantity span').textContent)-1));
  request.onload = updateCart
  if(parseInt(parseInt(el.parentNode.querySelector('.overlayCart__itemQuantity span').textContent)-1)==0) el.parentNode.parentNode.parentNode.remove();
  return false;
}

function increaseQty(el) {
  var request = new XMLHttpRequest();
  request.open('POST', '/cart/update.js', true);
  request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
  request.send('updates['+el.parentNode.parentNode.parentNode.dataset.id+']='+parseInt(parseInt(el.parentNode.querySelector('.overlayCart__itemQuantity span').textContent)+1));
  request.onload = updateCart
  if(parseInt(parseInt(el.parentNode.querySelector('.overlayCart__itemQuantity span').textContent)+1)==0) el.parentNode.parentNode.parentNode.remove();
  return false;
}

function openOverlayCart() {
  updateCart()
  document.querySelector('.overlayCart').classList.add('on')
}

function closeOverlayCart() {
  document.querySelector('.overlayCart').classList.remove('on')
}
*/

function logKey(e) {
  if (e.code == "Space") {
    e.preventDefault();
    if (document.querySelector("body").classList.contains("dev"))
      document.querySelector("body").classList.remove("dev");
    else document.querySelector("body").classList.add("dev");
  }
}

function indexInParent(node) {
  var children = node.parentNode.childNodes;
  var num = 0;
  for (var i = 0; i < children.length; i++) {
    if (children[i] == node) return num;
    if (children[i].nodeType == 1) num++;
  }
  return -1;
}

function is_touch_device() {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

function toggleAppUiElements() {
  if (!document.querySelector("#dummy-chat-button-iframe")) return;
  if (
    document.querySelector("#dummy-chat-button-iframe").style.display == "none"
  ) {
    document.querySelector("#dummy-chat-button-iframe").style.display = "";
  } else {
    document.querySelector("#dummy-chat-button-iframe").style.display = "none";
  }
}
const urlParams = new URLSearchParams(window.location.search);
const sales_token = urlParams.get("ts");
if (sales_token) {
  window.localStorage.setItem("kolsquare", JSON.stringify({ sales_token }));
}
